/*
 * Patches Dawn's PredictiveSearch.getSearchResults to query the AI service.
 * We patch the prototype rather than subclass into a new element so the native
 * <predictive-search> element name is kept — that matters because Dawn's CSS
 * (and the dropdown's visibility) is scoped to the `predictive-search` element
 * selector. A renamed element renders results but stays display:none.
 * Falls back to the native implementation on any failure or when AI is off.
 */
customElements.whenDefined('predictive-search').then(function () {
  const PS = customElements.get('predictive-search');
  if (!PS || PS.prototype.__aiPatched) return;

  const nativeGetSearchResults = PS.prototype.getSearchResults;

  PS.prototype.getSearchResults = function (searchTerm) {
    if (!window.AISearchClient || !window.AISearchClient.ready()) {
      return nativeGetSearchResults.call(this, searchTerm);
    }
    const self = this;
    self.setLiveRegionLoadingState();
    if (self._aiAbort) self._aiAbort.abort();
    self._aiAbort = new AbortController();

    window.AISearchClient.query(searchTerm, { signal: self._aiAbort.signal })
      .then(function (data) {
        if (data == null) {
          // Service unavailable → native predictive search.
          nativeGetSearchResults.call(self, searchTerm);
          return;
        }
        // Strong title match (server keyword score >= 80): remember it so Enter
        // can jump straight to the product instead of the results page.
        try {
          var bm = null;
          if (data.bestMatch) {
            (data.products || []).forEach(function (p) { if (p.slug === data.bestMatch) bm = p; });
          }
          self._aiBestMatch = bm;
          self._aiBestMatchTerm = searchTerm;
        } catch (e) {}
        self.renderSearchResults(window.AISearchClient.renderPredictive(data, searchTerm));
        try {
          if (window.AISearchAnalytics) {
            window.AISearchAnalytics.logSearch(searchTerm, (data.products || []).length + (data.articles || []).length, 'header');
          }
        } catch (e) {}
        // Every query: append recent 5-star reviews for the top matched products
        // (or, on zero results, for the semantic suggestions) as social proof —
        // ranked by query-vs-review-text similarity, capped at 2 cards.
        try {
          var prods = data.products || [];
          var pool = prods.length ? prods : (data.suggestions || []);
          if (pool.length && window.AISearchClient.reviewsHighlights) {
            var handles = pool.slice(0, 3).map(function (p) { return p.slug; });
            window.AISearchClient.reviewsHighlights(2, handles, searchTerm).then(function (revs) {
              if (!revs || !revs.length) return;
              if (self.getQuery() !== searchTerm) return; // stale — shopper kept typing
              var results = self.querySelector('#predictive-search-results');
              if (!results || results.querySelector('.ai-reviews--predictive')) return;
              var holder = document.createElement('div');
              holder.innerHTML = window.AISearchClient.renderPredictiveReviews(revs);
              var btn = results.querySelector('#predictive-search-option-search-keywords');
              results.insertBefore(holder.firstChild, btn);
            }).catch(function () {});
          }
        } catch (e) {}
      })
      .catch(function (error) {
        if (error && (error.name === 'AbortError' || error.code === 20)) return;
        nativeGetSearchResults.call(self, searchTerm);
      });
  };

  // Enter with a strong best match → straight to the product page. Document-
  // level CAPTURE listener, NOT a prototype patch: Dawn binds onFormSubmit at
  // element construction (`this.onFormSubmit.bind(this)`), which freezes the
  // original method before our patch can land — a prototype override is never
  // called. Capture phase on document runs before Dawn's form listener and the
  // native submission. Keyboard-selected options and stale terms stay native.
  document.addEventListener('submit', function (event) {
    try {
      var form = event.target;
      var ps = form && form.closest ? form.closest('predictive-search') : null;
      if (!ps || !ps._aiBestMatch) return;
      var bm = ps._aiBestMatch;
      var query = ps.getQuery ? ps.getQuery() : '';
      if (!query.length || ps._aiBestMatchTerm !== query) return; // stale → native
      if (ps.querySelector('[aria-selected="true"] a, button[aria-selected="true"]')) return; // keyboard selection → native
      event.preventDefault();
      event.stopPropagation();
      try {
        if (window.AISearchAnalytics) {
          window.AISearchAnalytics.logClick(bm.slug, 'product', 1, 'header'); // also marks search-sourced for cart attribution
        }
      } catch (e) {}
      window.location.href = bm.url;
    } catch (e) {}
  }, true);

  PS.prototype.__aiPatched = true;
});
